import { fade, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			all: 'unset',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			outline: `2px solid ${theme.palette.scoreapp.primary}`,
			outlineOffset: -2,
			backgroundColor: fade(theme.palette.common.white, 0.8),
			color: theme.palette.scoreapp.primary,
			zIndex: 1000,
			cursor: 'pointer',
			fontSize: 14,
			fontFamily: 'Instrument Sans',
			fontWeight: 500,
			transition: theme.transitions.create(['opacity']),
			'&:after': {
				content: '""',
				display: 'block',
				position: 'absolute',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: fade(theme.palette.scoreapp.primary, 0.17),
				zIndex: -1,
			},
		},
		icon: {
			marginRight: 10,
			width: '1.2em',
			height: '1.2em',
			marginTop: '-0.25em',
		},
	}),
	{ name: 'SectionItem-ThemeButton' },
)

export default useStyles
